import { takeEvery, call, put } from 'redux-saga/effects';
import {
  insertUpdateItems,
  dataRequest,
  requestInProgress,
  requestFinished
} from '../../../../../../common/reducers/listsCollection/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import LocaleService from '../../../../services/LocaleService';

function* dataRequestSaga(reducerName, action) {
  try {
    yield put(requestInProgress(reducerName, action.payload));
    const result = yield call(
      timeoutCall,
      LocaleService.getRegions,
      action.payload
    );
    if (result.response) {
      // status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateItems(reducerName, {
            itemsById: result.destructData.items,
            groupMapItemsIds: result.destructData.mapItems
          })
        );
      }
    }
    yield put(requestFinished(reducerName, action.payload));
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(dataRequest(reducerName).type, dataRequestSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/locale/reducers/static/collections/sagas/regionsCollectionSaga.js